import { parseEther } from "viem"

export const TOKEN_TOTAL_SUPPLY = parseEther("1000000000") // 1 billion tokens

/**
 * ParagraphCoinFactory addresses for each chain.
 */
export const COIN_FACTORY_ADDRESSES: Record<number, `0x${string}`> = {
  84532: "0x498B41Fed29CA2c8501d2A14a091bCF14Cefa136", // Base Sepolia
}
